import React, { useEffect } from "react";
import BankId from "./BankID/BankId.Component";
import BankIdPhone from "./BankID/BankIdPhone.Component";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import TwoStepLogin from "./Login.Two.Step.Component";

import OkIcon from "@material-ui/icons/VerifiedUser";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { TabContext, TabPanel } from "@material-ui/lab";

export function isTokenDateValid() {
  let jwt = localStorage.getItem("admin.usr");
  if (jwt) {
    let jwtExp = JSON.parse(jwt)["expires_in"];
    let dateNow = new Date().toUTCString();

    if (new Date(dateNow) < new Date(jwtExp)) {
      return true;
    }
  }
  return false;
}

const LoginComponent = () => {
  const [tabValue, setTabValue] = React.useState("bankId");

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (isTokenDateValid()) refreshTokenLogin();
  }, []);

  let adminWrapperStyle = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "100%",
    backgroundColor: "#f7f7f7",
    maxWidth: "100%",
    overflow: "hidden",
  };

  let adminCardStyle = {
    margin: "auto",
    width: "500px",
    position: "relative",
  };

  return (
    <MuiThemeProvider>
      <div style={adminWrapperStyle}>
        <div
          style={{
            border: "solid 1px black",
            marginBottom: "10px",
            backgroundColor: "#f3e5b2",
            padding: "10px",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
          }}
        >
          {" "}
          ReLoansys: log in to get access to time travel{" "}
        </div>
        <Card style={adminCardStyle}>
          <CardHeader
            title="Admin"
            subheader="login"
            avatar={
              <OkIcon
                style={{ fill: "green", height: "50px", width: "50px" }}
              />
            }
          />
          <CardContent>
            <TabContext value={tabValue}>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab style={{ flexGrow: 1 }} label="BankId" value={"bankId"} />
                {import.meta.env.MODE === "development" && (
                  <Tab
                    style={{ flexGrow: 1 }}
                    label="BankId Phone"
                    value={"bankIdPhone"}
                  />
                )}
                <Tab
                  style={{ flexGrow: 1 }}
                  label="Credentials"
                  value={"credentials"}
                />
              </Tabs>
              <div style={{ marginTop: "12px" }}>
                <TabPanel value={"bankId"}>
                  <BankId />
                </TabPanel>
                {import.meta.env.MODE === "development" && (
                  <TabPanel value={"bankIdPhone"}>
                    <BankIdPhone />
                  </TabPanel>
                )}
                <TabPanel value={"credentials"}>
                  <TwoStepLogin />
                </TabPanel>
              </div>
            </TabContext>
          </CardContent>
        </Card>
      </div>
    </MuiThemeProvider>
  );

  function refreshTokenLogin() {
    window.location.reload();
  }
};
export default LoginComponent;
